import Component from '../../lib/component'

export default class ProgressiveTextTableComponent extends Component {
    static selector () {
        return 'pre.progressive-text-table'
    }

    constructor (opts) {
        super(opts)

        if (this.getBrowser('name') === 'ie') {
            this.props.rendered = false
            return
        }

        // Non-blocking rendering
        setTimeout(() => {
            this.tables = this.getTables() || []
            this.render()
        }, 0)
    }

    getTextRows (textRows = (this.el.innerText || '')) {
        textRows = textRows
            .split(/\n/g)
            .filter(str => str.trim())
            .map(str => str
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>'))

        const getTextLength = (str) => str
            .replace(/(&[^;]+;)/g, '.')
            .length

        const isMultiRowHead = textRows
            .filter((str, idx) => str.match(/^\S/)
                && (str.match(/\s{2,}/g) || []).length < 1
                && (textRows[idx + 1] || '').match(/^\s\S/))
            .length

        // Normalize multi-row data rowheads
        if (isMultiRowHead) {
            textRows = textRows
                .map(str => str.match(/^\s*\S+/)
                        && str.match(/([a-zA-Z]\s)((?:\d|-|%)+\s*)+$/)
                        && str.match(/^(.+[a-zA-Z]\s)([\d|-|%]+\s{2,})/)
                    ? str.replace(/^(.+[a-zA-Z]\s)([\d|-|%]+\s{2,})/, '$1 $2')
                    : str)

            const firstColLength = textRows
                .filter(str => !str.match(/^\s{2,}/))
                .map(str => getTextLength(str
                    .replace(/\s{2,}.+$/, '')))
                .sort((a, b) => b - a)[0] || 0

            const rowheadsStart = textRows
                .filter((str, idx) => str.match(/^\S/)
                    && (textRows[idx + 1] || '').match(/^\s\S/))

            textRows = textRows
                .map((str, idx) => str.match(/^\s\S/)
                    ? `${(textRows[idx - 1] || '')
                        .replace(/\s+$/, '')}${str}`
                    : str)
                .filter(str => rowheadsStart.indexOf(str) < 0)

            const newFirstColLength = textRows
                .filter(str => !str.match(/^\s{2,}/))
                .map(str => getTextLength(str
                    .replace(/\s{2,}.+$/, '')))
                .sort((a, b) => b - a)[0] || 0

            textRows = textRows
                .map(str => str && str.match(/^\s{2,}/)
                    ? `${''.padStart(newFirstColLength
                        - firstColLength, ' ')}${str}`
                    : str)

            const dataColPadEnd = textRows
                .filter(str => str.match(/^\s{2,}/))
                .map(str => ((str.match(/\S/) || {}).index || 0))
                .sort((a, b) => a - b)[0] || newFirstColLength

            textRows = textRows
                .map((str) => {
                    if (!str || str.match(/^\s{2,}/))
                        return str

                    const parts = str
                        .replace(/\s{2,}/, ',,')
                        .split(/,,/)

                    return `${parts[0]
                        .padEnd(dataColPadEnd, ' ')}${parts[1]}`
                })
        }

        // Ensure colgroups are delimited by two spaces
        for (let i = 0; i < textRows.length; i++)
            if (textRows[i].match(/(\.{2,})\s(\S)/)
                    && textRows[i + 1]
                    && textRows[i + 1].match(/^\s/))
                textRows[i]
                    .match(/(\S+\.{2,}\s)(?!\s|$)/g)
                    .forEach((str, idx) => {
                        const startIdx = textRows[i].indexOf(str) + idx
                        const endIdx = startIdx + str.length

                        textRows[i + 1] = `${textRows[i + 1]
                            .substring(0, endIdx)} ${textRows[i + 1]
                            .slice(endIdx)}`

                        textRows[i] = `${textRows[i]
                            .substring(0, endIdx)} ${textRows[i]
                            .slice(endIdx)}`
                    })

        const getCols = (row) => row
            .split(/\s{2,}/)
            .filter(str => str.trim())

        textRows = textRows
            .map(str => str
                .replace(/\s{1}([<|>]\d{1,}k)/gi, '  $1'))
            .map(str => str.match(/^\s{2,}/)
                ? str.replace(/([a-z]{2,})(\s[A-Z]{2,})/g, '$1 $2')
                : str)
            .map(str => str.match(/^\s{2,}/)
                    && str.match(/(\S\s)([A-Z]{2}\/[A-Z{2}])/)
                    && str.match()
                ? str.replace(/(\S\s)([A-Z]{2}\/[A-Z]{2})/g, '$1 $2')
                : str)
            .map((str, idx) => idx
                    && str.match(/^\s{2,}/)
                    && str.match(/[a-z]/)
                ? str.replace(
                    /^(\s{2,})([A-Z][a-z]{2,})\s([A-Z])/, '$1$2  $3')
                : str)
            .map(str => {
                if (!str.match(/^\s{2,}/)
                        || !str.match(/(\S.+\.{2,}(?=\s))/))
                    return str

                getCols(str)
                    .filter(_str => _str.match(/\.{2,}/)
                        && _str.match(/[a-z]/))
                    .forEach(_str => {
                        str = str.replace(_str, _str.toUpperCase())
                    })

                return str
            })

        let headRows = textRows
            .filter(str => str.match(/^\s{2,}/))

        const colsTotal = textRows
            .map(str => str.split(/\s{2,}/)
                .filter(str => str.trim())
                .length)
            .sort((a, b) => b - a)[0]

        const getColIdx = (row, col) =>
            row.indexOf(col)

        const getColEndIdx = (row, col) =>
            getColIdx(row, col) + col.length

        const mixedColgroupsCols = headRows
            .filter((str, idx) => {
                if (!str.match(/[a-z]/))
                    return

                if (str.match(/([^a-z\s]+\.{2,})/))
                    return str

                const cols = getCols(str)

                return cols.filter(_str => _str.match(/[A-Z]{3,}/)).length
                    && cols.length !== colsTotal - 1
            })

        if (mixedColgroupsCols.length) {
            const getRowsByColType = (type = 'colgroup') =>
                mixedColgroupsCols
                    .map((str) => {
                        getCols(str)
                            .filter(col => type === 'colgroup'
                                ? !col.match(/[A-Z]{2,}/)
                                : col.match(/[A-Z]{2,}/))
                            .forEach(col => {
                                str = str.replace(col,
                                    ''.padStart(col.length))
                            })

                        return str
                    })

            const setTextRows = (rows = []) => rows
                .forEach((str, idx) => {
                    const mixedRow = !idx
                        ? mixedColgroupsCols[idx]
                        : mixedColgroupsCols[idx - 1]

                    const mixedRowIdx = textRows
                        .indexOf(mixedRow)

                    const rowsPre = mixedRowIdx
                        ? textRows.slice(0, mixedRowIdx)
                        : []

                    const rowsPost = textRows.slice(mixedRowIdx + 1)

                    textRows = rowsPre
                        .concat([str, mixedRow])
                        .concat(rowsPost)
                })

            setTextRows(getRowsByColType('colgroup'))
            setTextRows(getRowsByColType('colhead'))

            textRows = textRows
                .filter(str => mixedColgroupsCols.indexOf(str) < 0)

            headRows = textRows
                .filter(str => str.match(/^\s{2,}/))
        }

        const collapseHeadRows = (rows) => {
            const _headRows = rows
                .filter(str => str.match(/^\s{2,}/))

            // Collapse non-multirow colgroups
            const collapsibleHeadRows = _headRows
                .filter((str, idx) => !str.match(/[a-z]/)
                    && _headRows[idx + 1]
                    && (!_headRows[idx + 1].match(/([a-z]|%)/)
                        || (!str.match(/\.{2,}/)
                            && !idx)))

            if (!collapsibleHeadRows.length)
                return rows

            collapsibleHeadRows
                .forEach((str, idx) => {
                    const textRowIdx = rows.indexOf(str)

                    let nextRow = String(rows[textRowIdx + 1])

                    const cols = getCols(str)

                    const colsCollapsible = cols
                        .filter((_str) => !nextRow
                            .substring(getColIdx(str, _str),
                                getColEndIdx(str, _str))
                            .trim())

                    if (cols.length !== colsCollapsible.length)
                        return

                    cols
                        .forEach(_str => {
                            nextRow = `${
                                nextRow.substring(0, getColIdx(str, _str))}${
                                _str}${
                                nextRow.substring(getColEndIdx(str, _str))}`
                        })

                    rows[textRowIdx] = ''
                    rows[textRowIdx + 1] = nextRow
                })

            return rows
                .filter(str => str.trim())
        }

        textRows = collapseHeadRows([...textRows])

        headRows = textRows
            .filter(str => str.match(/^\s{2,}/))

        const getMultiRowColEnd = (nextRow, row, col) => {
            const nextRowCol = nextRow
                .substring(getColIdx(row, col) - 1)
                .replace(/\s{2,}.+$/, '')

            return nextRowCol.match(/^\s[^a-z]{2,}/)
                    && !nextRowCol.match(/^\s{2,}/)
                ? nextRowCol
                : null
        }

        const multiRowColStart = headRows
            .filter((str, idx) => {
                const textRowIdx = textRows.indexOf(str)
                const nextRow = String(textRows[textRowIdx + 1] || '')

                if (str.match(/[a-z]/)
                        || str.match(/\.{2,}/)
                        || nextRow.match(/\.{2,}/))
                    return

                const cols = getCols(str)
                    .filter(_str => !_str.match(/\.{2,}/)
                        && _str.length > 2)

                const nextRowCols = getCols(nextRow
                    .replace(/([a-z]{2,})\s([A-Z]\S+\s)/g, '$1  $2'))

                return cols.length
                        && !nextRow.match(/[a-z]/)
                        && (nextRowCols.length !== colsTotal - 1
                            || nextRowCols.filter(str => str.length > 2).length)
                    ? cols
                        .filter(_str => getMultiRowColEnd(nextRow, str, _str))
                        .length
                    : false
            })

        if (multiRowColStart.length) {
            let _textRows = [...textRows]

            multiRowColStart
                .forEach((str) => {
                    const textRowIdx = textRows.indexOf(str)

                    const nextRow = String(textRows[textRowIdx + 1])

                    const colsCollapsible = getCols(str)
                        .filter(_str => getMultiRowColEnd(nextRow, str, _str))

                    let row = String(str)

                    colsCollapsible
                        .forEach((_str) => {
                            const colEnd = getMultiRowColEnd(nextRow, str, _str)

                            const col = `${_str.trim()}${
                                _str.trim().match(/\/$/)
                                    ? ''
                                    : ' '}${colEnd.trim()}`

                            row = row.replace(_str, col)

                            const cols = getCols(nextRow)

                            const isLastCol = cols.indexOf(colEnd)
                                === cols.length - 1

                            _textRows = _textRows
                                .map((_row, _idx) => {
                                    if (_idx === textRowIdx)
                                        return _row.replace(_str, col)

                                    if (_idx === textRowIdx + 1)
                                        _row = _row
                                            .replace(colEnd,
                                                colEnd.replace(/./g, ' '))

                                    if (isLastCol)
                                        return _row

                                    const strStart = _row
                                        .substring(0, getColEndIdx(row, _str) + 2)

                                    const strPad = ''
                                        .padStart(colEnd.length > _str.length
                                            ? colEnd.length
                                            : _str.length, ' ')

                                    const strEnd = _row
                                        .substring(getColEndIdx(row, _str) + 2)

                                    return `${strStart}${strPad}${strEnd}`
                                })
                        })
                })

            textRows = collapseHeadRows([..._textRows])
                .map(str => str.match(/^\S+/)
                        && getCols(str).length === colsTotal
                    ? str.replace(/\s{2,}$/, '  ')
                    : str)
        }

        textRows = textRows
            .map(str => str
                .replace(/(\.{2,})(\s\S)/g, '$1 $2'))
            .map(str => str.match(/^\S/)
                    && str.match(/([a-zA-Z)]\s)((?:\d|-|%)+\s*)+$/)
                    && str.match(/^(.+\S(?!\s{2,}))+(\s[\d-%]+\s{2,})/)
                ? str.replace(/^(.+\S(?!\s{2,}))+(\s[\d-%]+\s{2,})/, '$1  $2')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/[a-z]/)
                ? str.replace(/(\/)\s(\S)/g, '$1  $2')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/([A-Z][a-z]+\s(?=[A-Z]))/)
                ? str.replace(/([A-Z][a-z]{3,}\s(?=[A-Z]))/g, '$1 ')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/([A-Z]+\s)([A-Z][a-z])/)
                ? str.replace(/([A-Z]+\s)([A-Z][a-z])/g, '$1 $2')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/(\d{1,}-\d{1,})\s(\d{1,}.+)/)
                ? str.replace(/(\d{1,}-\d{1,})\s(\d{1,}.+)/g, '$1  $2')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/([A-Za-z]+[a-z])\s([A-Z]{3,})$/)
                ? str.replace(/([A-Za-z]+[a-z])\s([A-Z]{3,})$/, '$1  $2')
                : str)
            .map(str => str.match(/^\s{2}/)
                    && str.match(/[a-z]/)
                ? str.replace(/([a-z]{2,})\s([A-Z]\S+\s)/g, '$1  $2')
                : str)
            .map((str, idx) => !idx
                    && str.match(/^\s{2}/)
                    && str.match(/[a-z]/)
                    && str.split(/\s{2,}/).length !== colsTotal
                ? str.replace(/(\s{2}[A-Za-z]+-)\s([A-Z][A-Za-z]{2,})/,
                    '$1  $2')
                : str)
            .map((str, idx) => {
                if (idx
                        || !str.match(/^\s{2}/)
                        || !str.match(/((?:\w\s?)+\w)(\s{2,})/)
                        || str.match(/[a-z]/))
                    return str

                if (!str.match(/\.{2,}/)
                        && getCols(textRows[idx + 1] || '')
                            .length === colsTotal - 1) {
                    const colsStr = str
                        .replace(/^\s{2,}/, '')
                        .replace(/\s{2,}$/, '')

                    const colsStart = getColIdx(str, colsStr)

                    const colsEnd = getColEndIdx(str, colsStr)

                    const nextRowColsStr = (textRows[idx + 1] || '')
                        .substring(colsStart, colsEnd)

                    if (nextRowColsStr.trim()
                            && getCols(nextRowColsStr).length
                                === getCols(colsStr).length)
                        return str
                }

                const colgroups = str
                    .match(/((?:\w\s?)+\w)(\s{2,})/g) || []

                colgroups
                    .filter(colgroup => !colgroup.match(/\.{2,}/)
                        && colgroup.trim().length > 2)
                    .forEach(colgroup => {
                        str = str.replace(colgroup,
                            colgroup.replace(/\s{2}/, '..'))
                    })

                const cols = getCols(str)

                if (!str.match(/\.{2,}$/)
                        && str.match(/\S$/)
                        && cols[cols.length - 1].length > 2)
                    str += '..'

                return str
            })

        headRows = textRows
            .filter(str => str.match(/^\s{2,}/))

        if (headRows.length > 1
                && headRows[headRows.length - 1]
                    .split(/\s{2,}/g)
                    .filter((str, idx) => str || !idx).length
                        === colsTotal - 1
                && (headRows[headRows.length - 2] || '').match(/[a-z]/)) {
            const textRowIdx = textRows
                .indexOf(headRows[headRows.length - 1])

            textRows[textRowIdx] = textRows[textRowIdx]
                .replace(/(\s{2,}[a-z]{3,}\s)([a-z]{3,})/, '$1 $2')
        }

        return textRows
    }

    getRows (rows = this.getTextRows()) {
        const textRows = [...rows]

        const colsTotal = textRows
            .map(str => str.split(/\s{2,}/)
                .filter(str => str.trim())
                .length)
            .sort((a, b) => b - a)[0]

        // Convert Text Rows to CSV like format
        rows = rows
            .map(str => str.match(/\S{3,}\s{3,}$/)
                ? str.replace(/(\S)(\s+)$/, '$1,,$2')
                : str)
            .map(str => str
                .replace(/(\s{2,})/g, '$1,,')
                .replace(/,,$/, ''))
            .map(str => !str.match(/^\s+/)
                    || (str.match(/[a-z]/)
                        && !str.match(/\.{2,}/))
                    || !str.match(/([A-Z]|[0-9]){3,}/)
                ? str
                : str.replace(/([A-Z|0-9])(\s{3,})(,,)/g, '$1,,$2$3'))
            .map(str => str.split(/,,/))
            .map(arr => arr
                .filter((str, idx) => arr.length <= colsTotal
                    || (idx && str.trim())
                    || !idx))
            .map((arr, idx) => arr.length !== colsTotal
                    && textRows[idx].match(/^\s{2,}/)
                    && textRows[idx].split(/\s{2,}/).length
                        !== colsTotal - 1
                    && arr.filter(str => str.trim()
                        && str.match(/\s{4,}$/)).length
                ? arr
                    .map(str => str.match(/\s{4,}$/)
                            && str.trim()
                        ? str
                            .replace(/(\s{2})/, ',,$1')
                            .split(/,,/)
                        : str)
                    .reduce((acc, curr) => acc
                        .concat(Array.isArray(curr)
                            ? curr
                            : [curr]), [])
                : arr)

        const dataRowsColsIdx = []

        textRows
            .forEach((str) => {
                if (str.trim().split(/\s{2,}/).length !== colsTotal)
                    return

                let match
                const matches = []
                const regexp = /,,/g
                const colStr = `,,${str
                    .replace(/(\s{2,})/g, '$1,,')}`

                while ((match = regexp.exec(colStr)) !== null)
                    matches.push(match)

                matches
                    .map((val, idx) => idx && val.index
                        ? val.index - (val[0].length * idx)
                        : 0)
                    .forEach((val, idx) => {
                        dataRowsColsIdx[idx] = !dataRowsColsIdx[idx]
                                || val < dataRowsColsIdx[idx]
                            ? val
                            : dataRowsColsIdx[idx]
                    })
            })

        const isDataRowsMissingCols = textRows
            .map(str => str.split(/\s{2,}/)
                .filter(str => str.trim()))
            .filter(arr => arr.length !== colsTotal)
            .length

        return rows
            .map((arr, idx) => {
                if (!isDataRowsMissingCols
                        || arr.length === colsTotal
                        || !textRows[idx].match(/^\S/))
                    return arr

                for (let i = 0; i < dataRowsColsIdx.length; i++) {
                    const colStartIdx = dataRowsColsIdx[i]

                    const colEndIdx = dataRowsColsIdx[i + 1]
                        || textRows[idx].length

                    const isValidCol = (textRows[idx]
                        .substring(colStartIdx, colEndIdx) || '')
                        .trim()

                    if (isValidCol)
                        continue

                    arr = arr.slice(0, i)
                        .concat([''])
                        .concat(arr.slice(i))
                }

                return arr
            })
            .map(arr => arr
                .map(str => str.trim()))
            .map((arr, idx) => {
                const textRow = textRows[idx]
                const isColGroup = textRow.match(/\.{2,}/)

                arr = arr
                    .map((str, i) => {
                        const obj = {
                            text: str,
                            colspan: null,
                            scope: null,
                            tagName: 'td',
                            colStart: arr.length === colsTotal
                                ? i
                                : 0,
                            colEnd: arr.length === colsTotal
                                ? i + 1
                                : 0
                        }

                        if (arr.length === colsTotal
                                || (!i && !str)
                                || !isColGroup) {
                            const isTableHead = (!i && str)
                                || !arr[0]

                            if (isTableHead) {
                                obj.scope = !i
                                    ? 'row'
                                    : 'col'

                                obj.tagName = 'th'
                            }

                            if (arr.length === colsTotal)
                                obj.colspan = 1
                        }

                        return obj
                    })

                if (arr.length === colsTotal)
                    return arr

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].text) {
                        arr[i].tagName = 'th'
                        arr[i].scope = arr[i].scope || 'col'
                    }

                    const colStartIdx = i && arr[i].text
                        ? textRow.indexOf(arr[i].text)
                        : (i && arr[i - 1].text
                            ? textRow.indexOf(arr[i - 1].text)
                                + arr[i - 1].text.length
                                + 1
                            : 0)

                    const colEndIdx = arr[i].text
                        ? colStartIdx + arr[i].text.length
                        : ((arr[i + 1] || {}).text
                            ? textRow.indexOf(arr[i + 1].text) - 1
                            : textRow.length)

                    const colspan = dataRowsColsIdx
                        .filter(int => int >= colStartIdx
                            && int < colEndIdx)
                        .length

                    if (colspan && !arr[i].colspan)
                        arr[i].colspan = colspan

                    if (arr[i].colspan
                            && arr[i].text
                            && !textRow.match(/[a-z]/)) {
                        const textColspan = textRows
                            .filter(str => str
                                .split(/\s{2,}/g)
                                .length
                                    === colsTotal)
                            .map(str => str
                                .substring(colStartIdx, colEndIdx - 1)
                                .split(/\s{2,}/g)
                                .filter(str => str.trim())
                                .length)
                            .sort((a, b) => b - a)[0]

                        if (textColspan > colspan)
                            arr[i].colspan = textColspan
                    }

                    if (!arr[i].colspan
                            && arr[i].text
                            && textRow.match(/[a-z]/))
                        arr[i].colspan = 1

                    arr[i].colStart = i
                        ? (arr[i - 1].colEnd || 0)
                        : i

                    arr[i].colEnd = arr[i].colStart + arr[i].colspan

                    if (arr[i].colspan > 1 && arr[i].text)
                        arr[i].scope = 'colgroup'
                }

                return arr
                    .filter(obj => obj.colspan)
            })
            .map((arr, idx, self) => {
                const isHeadCol = (obj) => obj.text
                    && obj.scope === 'col'

                const getHeadCols = (row = []) => row
                    .filter(obj => isHeadCol(obj))

                if (!getHeadCols(arr).length
                        || !getHeadCols(self[idx + 1]).length)
                    return arr

                return arr
                    .map(obj => {
                        if (!isHeadCol(obj))
                            return obj

                        const nextRowColIdx = self[idx + 1]
                            .map((_obj, i) => _obj.colStart === obj.colStart
                                    && _obj.colspan === obj.colspan
                                ? i
                                : -1)
                            .sort((a, b) => b - a)[0]

                        const nextRowCol = self[idx + 1][nextRowColIdx]

                        if (!nextRowCol)
                            return obj

                        self[idx + 1][nextRowColIdx].text
                            = (obj.text.match(/-$/)
                                ? `${obj.text.replace(/-$/, '')}${
                                    nextRowCol.text}`
                                : `${obj.text} ${nextRowCol.text}`
                                    .replace(/(\/)\s{1}/, '$1'))
                                .replace(/([a-z])([A-Z])/g, '$1 $2')

                        obj.text = ''
                        obj.scope = null
                        obj.tagName = 'td'

                        return obj
                    })
            })
            .filter(arr => arr
                .filter(obj => obj.text)
                .length)
            .map(arr => arr
                .map((obj, idx) => {
                    obj.text = (obj.text || '')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/\.{2,}/, '')
                        .trim()

                    if (obj.tagName === 'th'
                            && !obj.text
                            && idx) {
                        obj.scope = null
                        obj.tagName = 'td'
                    }

                    obj.id = obj.tagName === 'th' && obj.text
                        ? `table-row-header-${this.generateGUID()}`
                        : null

                    if (!obj.colspan)
                        obj.colspan = 1

                    return obj
                }))
    }

    getTables (str = (this.el.innerText || '')) {
        const tableDelimiter = '\n<!--SPLIT-->\n'

        return str
            .replace(/^\s+(^\S)/gm, '$1')
            .replace(/(^\S.+$)\n{2,}(^\s+\S.+$)/gm,
                `$1${tableDelimiter}$2`)
            .split(tableDelimiter)
            .filter(str => str.trim())
            .map(str => this.getRows(this.getTextRows(str)))
    }

    getTablesHTML (tables = this.tables) {
        const isRowColgroup = (row) => row
            .filter(obj => (obj.scope === 'colgroup'
                    && obj.tagName === 'th'))
            .length

        const isRowHead = (row) => row
            .filter(obj => (obj.scope === 'col'
                && obj.colspan === 1
                && obj.tagName === 'th'))
            .length

        return tables
            .map((rows, idx) => rows.filter(arr =>
                !(arr[arr.length - 1] || {}).text).length
                    === rows.length
                ? rows.map(arr => arr.slice(0, arr.length - 1))
                : rows)
            .map((rows, idx) => {
                const headerRowCols = rows
                    .filter(row => isRowColgroup(row)
                        || isRowHead(row))
                    .map(row => row
                        .filter(obj => obj.id))
                    .reduce((acc, curr) => acc.concat(curr), [])

                const dataRows = rows
                    .filter(row => !isRowColgroup(row)
                        && !isRowHead(row))

                return rows
                    .map((row) => {
                        let classname = ''

                        if (isRowHead(row))
                            classname = 'table-row-head'

                        if (isRowColgroup(row))
                            classname = 'table-row-colgroup'

                        const cols = row
                            .map((obj, _idx) => {
                                let attrs = ''

                                if (classname
                                        && !obj.scope
                                        && !obj.text
                                        && !_idx) {
                                    obj.scope = 'row'
                                    obj.tagName = 'th'
                                }

                                if (obj.id)
                                    attrs += ` id="${obj.id}"`

                                if (obj.scope)
                                    attrs += ` scope="${obj.scope}"`

                                if (obj.scope === 'row')
                                    attrs += ' role="rowheader"'

                                if (obj.colspan !== 1)
                                    attrs += ` colspan="${obj.colspan}"`

                                if (obj.tagName === 'th' && obj.text)
                                    attrs += ' class="table-row-header"'

                                if (!classname
                                        && obj.tagName === 'td'
                                        && obj.text) {
                                    let headers = _idx
                                            && row[0].scope === 'row'
                                            && row[0].id
                                        ? `${row[0].id} `
                                        : ''

                                    headers += headerRowCols
                                        .filter(_obj => _obj.colStart
                                                <= obj.colStart
                                            && _obj.colEnd >= obj.colEnd)
                                        .map(_obj => _obj.id)
                                        .reverse()
                                        .join(' ')

                                    headers = headers.trim()

                                    if (headers)
                                        attrs += ` headers="${headers}"`
                                }

                                const contents = (() => {
                                    if (!obj.text
                                            && obj.tagName === 'td')
                                        return ''

                                    let _attrs = ''

                                    if (!obj.text
                                            && obj.tagName === 'th') {
                                        obj.text = '-'
                                        _attrs += ' aria-hidden="true"'
                                        _attrs += ' class="text-screen-reader"'
                                    }

                                    if (obj.text === '-'
                                            && obj.tagName === 'td')
                                        _attrs += ' aria-label="0"'

                                    if (obj.text
                                            && obj.tagName === 'td'
                                            && (obj.text === '-'
                                                || obj.text.match(/^[0-9]{1,2}$/)))
                                        _attrs += ' class="table-row-data-digit"'

                                    if (obj.text
                                            && obj.tagName === 'td'
                                            && obj.text.match(/^[0-9]{1,2}%$/))
                                        _attrs += ' class="table-row-data-percent"'

                                    return `<span${_attrs}>${obj.text || ''}</span>`
                                })()

                                return `
                                    <${obj.tagName}${attrs}>
                                        ${contents}
                                    </${obj.tagName}>`
                                    .replace(/(\s{2,}|\n)/g, '')
                            })

                        if (!classname)
                            classname = `table-row-data table-row-data-${
                                !((dataRows.indexOf(row) + 1) % 2)
                                    ? 'even'
                                    : 'odd'}`

                        const classAttr = ` class="${classname}"`

                        return `<tr${classAttr} role="row">${cols.join('')}</tr>`
                    })
            })
            .map((rows) => {
                const classname = 'table-sticky-column'

                const ariaLabelledBy = this.el.getAttribute('aria-labelledby')

                const ariaLabelledByAttr = ariaLabelledBy
                        && this.getBrowser('os') !== 'android'
                    ? `aria-labelledby="${ariaLabelledBy}"`
                    : ''

                return `
                    <div class="${classname}">
                        <div class="${classname}-scrollable-bg"></div>
                        <div class="${classname}-container">
                            <table
                                class="${classname}-data navy"
                                ${ariaLabelledByAttr}
                            >
                                <tbody>${rows.join('')}</tbody>
                            </table>
                        </div>
                    </div>`
                    .replace(/(\s{2,}|\n)/g, ' ')
            })
            .join('\n')
    }

    render () {
        if (!this.el.id)
            this.el.id = `progressive-text-table-${this.generateGUID()}`

        this.el.outerHTML = `${this.el.outerHTML}\n${this.getTablesHTML()}`

        this.el = document.querySelector(`#${this.el.id}`)

        this.el.remove()
    }
}
